export default "__VITE_ASSET__BrhXYzkt__"